export default "__VITE_ASSET__CyGIrrGH__"